
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { SuccessHeading } from './components/SuccessHeading';
import { TransactionCard } from './components/TransactionCard';
import { TransactionDetails } from './components/TransactionDetails';
import {
  ContextColorProvider,
  NavBar,
  ButtonPrimary,
  IconButton
} from '@warrenbrasil/nebraska-web';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { PortfolioModule } from '@/store/modules/PortfolioModule';
import { GtmTracker } from '@/modules/common/services/analytics';

interface TransactionDetailsState {
  portfolioName: string;
  amount: string;
}

@Component({
  name: 'InvestmentSuccessView',
  components: {
    ContextColorProvider,
    TransactionDetails,
    TransactionCard,
    SuccessHeading,
    IconButton,
    NavBar,
    ButtonPrimary
  }
})
export default class InvestmentSuccessView extends Vue {
  @Prop({ type: String, required: true })
  private portfolioId!: string;

  private transactionDetails: null | TransactionDetailsState = null;
  private shouldShowTypeform = false;
  private readonly typeformId = 'WB27trlr';

  private created() {
    this.getTransactionDetails();
  }

  private get NebraskaColors() {
    return NebraskaColors;
  }

  get hasAnotherPortfolioToInvest() {
    return PortfolioModule.hasPortfolioToInvest;
  }

  private getTransactionDetails() {
    const { portfolioName, amount } = this.$route.query;
    const formattedAmount = amount
      ? moneyFormat(Number(amount))
      : 'Valor indefinido';

    this.transactionDetails = {
      portfolioName: portfolioName as string,
      amount: formattedAmount
    };
  }

  private handleBackClick() {
    this.redirectBackToWallet();
    PortfolioModule.resetInvestedPortfolios();
  }

  private handleInvestButtonClick() {
    this.redirectToPortfoliosToInvest();
  }

  private redirectToPortfoliosToInvest() {
    this.trackNewInvestmentDesire();
    this.$router.replace({ name: 'portfoliosToInvest' });
  }

  private trackNewInvestmentDesire() {
    GtmTracker.trackEvent({
      category: 'PEX - Investir Carteira',
      action: 'Clique Investir em Outra Carteira',
      label: this.transactionDetails!.portfolioName
    });
  }

  private redirectBackToWallet() {
    const id = this.portfolioId;
    this.$router.replace({ name: 'wealthPortfolio', params: { id } });
  }
}
